import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { onElementResize } from './helpers'


(function () {

    // Update Scroll Trigger on body height change duo to Ajax request or Filter ..etc 
    gsap.registerPlugin(ScrollTrigger);
    onElementResize(document.body, () => { ScrollTrigger.refresh(); })
    let width = screen.width;

    const staggerContainers = document.querySelectorAll('.animation-stagger-container');
    if (width > 769) {

        staggerContainers.forEach((c, indx) => {
            // items
            const staggerItems = c.querySelectorAll('.animation-item');
            gsap.from(staggerItems, {
                scrollTrigger: {
                    trigger: c,
                    start: "top 120%",
                    end: "bottom bottom",
                    scrub: true
                },
                opacity: 0.3,
                y: 80,
                stagger: 0.1
            });
        })
    }

    const parallaxImageContainers = document.querySelectorAll('.animation-parallax-image-container')

    parallaxImageContainers.forEach((c, indx) => {
        //console.log(c,indx)
        // items
        const staggerItems = c.querySelectorAll('.animation-item');
        gsap.from(staggerItems, {
            scrollTrigger: {
                trigger: c,
                start: "top 120%",
                end: "bottom center",
                scrub: true,
            },
            y: 120,
            stagger: 0.1,
        });
    })

    const countContainers = document.querySelectorAll('.animation-count');
    countContainers.forEach((sct, indx) => {
        gsap.fromTo(sct, {
            innerText: 0,
        }, {
            innerText: sct.getAttribute("data-number") + (sct.getAttribute("data-number-suffix") ? sct.getAttribute("data-number-suffix").toString() : ''),
            snap: { innerText: 1 },
            duration: 1,
            scrollTrigger: {
                trigger: sct,
                start: "top bottom",
                end: "bottom bottom",
                //markers: true,
            },

        });

    });


    const hlContainers = document.querySelectorAll('.animation-underline');
    hlContainers.forEach((hl) => {
        gsap.to(hl, {
            scrollTrigger: {
                trigger: hl,
                once: true,
                //scrub: true,
                start: "bottom bottom",
                //end: "bottom -100%",
                toggleClass: "on",
                ease: "power2",
            }
        });
    });





})();